import { t } from "i18next";

import { Box, ListItem, Typography, useMediaQuery } from "@mui/material";

import { theme } from "@/src/theme/theme";

import {
  CONSUMER_HOMEPAGE_PREFIX,
  HOMEPAGE_CONTAINER_STYLES
} from "@/src/pages/consumer/HomePage/homePage.constants";

import { VehicleType } from "@/src/types/types";

interface HomePageDescriptionProps {
  vehicleType: VehicleType;
}

const DESCRIPTION_LIST_ITEM_INDEXES = [1, 2, 3] as const;

export const HomePageDescription = ({
  vehicleType
}: HomePageDescriptionProps) => {
  const isSmallScreen = useMediaQuery("(max-width: 1000px)");

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        ...HOMEPAGE_CONTAINER_STYLES,
        mt: [-3, -2, -3],
        display: "flex",
        flexDirection: isSmallScreen ? "column" : "row"
      }}
    >
      <Box
        sx={{
          marginRight: isSmallScreen ? 0 : "20px",
          mb: 2
        }}
      >
        <Typography variant="h2" sx={{ mb: 0 }}>
          {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.descriptionHeader`)}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: ["column", "column", "row"]
          }}
        >
          {DESCRIPTION_LIST_ITEM_INDEXES.map((item) => (
            <ListItem
              key={`descriptionListItem-${item}`}
              sx={{
                pl: 0
              }}
            >
              <Box
                sx={{
                  "&:before": {
                    content: "''",
                    display: "block",
                    minHeight: "25px",
                    minWidth: "25px",
                    backgroundImage: "url('/assets/images/checkmark.webp')",
                    backgroundSize: "100% auto",
                    backgroundPosition: "top",
                    backgroundRepeat: "no-repeat",
                    marginRight: 2,
                    fontStyle: "normal"
                  }
                }}
              />
              {t(
                `${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.descriptionListItem-${item}`
              )}
            </ListItem>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
